import { cn } from '../../lib/cn';

const variants = {
  default:  'bg-[var(--bg-muted)] text-[var(--text-secondary)]',
  blue:     'bg-[var(--accent-muted)] text-[var(--accent)]',
  green:    'bg-[var(--success-muted)] text-[var(--success)]',
  yellow:   'bg-[var(--warning-muted)] text-[var(--warning)]',
  red:      'bg-[var(--danger-muted)] text-[var(--danger)]',
  purple:   'bg-[var(--purple-muted)] text-[var(--purple)]',
};

export function Badge({ variant='default', className, children, dot, ...props }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-semibold rounded-full', variants[variant], className)} {...props}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
